import classNames                                from 'classnames';
import _                                         from 'underscore';
import React, { FC, useContext, useRef }         from 'react';
import { Button, Dropdown, Icon, SemanticICONS } from 'semantic-ui-react';
import { CSVLink }                               from 'react-csv';
import { CopyToClipboard }                       from 'react-copy-to-clipboard';
import { ClassValue }                            from 'classnames/types';

import { DynamicComponentsContext }                       from '../../contexts';
import { Flexbox, FlexItem }                              from '../../containers';
import { Align, FlexAlign, SemanticUIColor, SystemEvent } from '../../../types';

export interface DataCopyMenuProps {
    className?: ClassValue,
    label?: string,
    icon?: SemanticICONS,
    iconColor?: SemanticUIColor,
    linkColor?: SemanticUIColor,
    direction?: Align.LEFT | Align.RIGHT,

    csvData?: {
        headers: Array<{ key: string, label: string }>,
        data: Array<object>,
        [ additionalProps: string ]: any
    };

    onGenerateCSV?( e: SystemEvent ): void;

    onSaveImage?( e: SystemEvent ): void;

    onCopyToClipboard?( text: string, result: boolean ): void;

    copyToClipboardText?: string,
    copyToClipboardOnly?: boolean,

    [ additionalProps: string ]: any
}

const defaultProps: DataCopyMenuProps = {
    className:           null,
    label:               'Menu',
    icon:                null,
    iconColor:           SemanticUIColor.PURPLE,
    linkColor:           SemanticUIColor.PURPLE,
    direction:           Align.RIGHT,
    onSaveImage:         null,
    csvData:             null,
    onGenerateCSV:       null,
    onCopyToClipboard:   null,
    copyToClipboardText: '',
    copyToClipboardOnly: false,
}

const DataCopyMenu: FC<DataCopyMenuProps> = ( _props ) => {

    let { modal: [ modal, modalActions ] }                                    = useContext( DynamicComponentsContext ),
        csvLinkRef                                                            = useRef<HTMLAnchorElement | null>(),
        { className, direction, label, icon, iconColor, linkColor, ...props } = _props;

    let dropdownProps = _.omit( props, [
        'onSaveImage',
        'csvData',
        'onGenerateCSV',
        'onCopyToClipboard',
        'copyToClipboardText',
    ] );

    let handleCSVAreaClicked = ( e: SystemEvent ) => {

        if( csvLinkRef.current ){

            let csvLinkEl = csvLinkRef.current.getElementsByTagName( 'A' )[ 0 ] as HTMLAnchorElement;

            if( csvLinkEl ){
                csvLinkEl.click();
            }
        }
    };

    let handleCSVIconClicked = ( e: SystemEvent ) => {

        e.stopPropagation();

        handleCSVAreaClicked( e );
    }

    let handleCSVLinkClicked = ( e: SystemEvent ) => {

        e.stopPropagation();

        if( _.isFunction( props.onGenerateCSV ) ){
            props.onGenerateCSV( e );
        }
    }

    if( props.copyToClipboardOnly ){

        return (
            <>
                {/* COPY TO CLIPBOARD */ }
                { ( _.isFunction( props.onCopyToClipboard ) || !_.isEmpty( props.copyToClipboardText ) ) &&
                  <CopyToClipboard text={ props.copyToClipboardText } onCopy={ props.onCopyToClipboard }>
                      <Button
                          basic={ true }
                          icon={ {
                              name:  'copy outline',
                              color: 'purple'
                          } }
                          content={ <>{ label ?? `Copy to Clipboard` }</> }/>
                  </CopyToClipboard> }
            </>
        )
    }


    return (

        <Dropdown direction={ direction }
                  icon={ null }
                  closeOnEscape={ true }
                  closeOnBlur={ true }
                  openOnFocus={ true }
                  closeOnChange={ true }
                  trigger={
                      <Flexbox className={ `text--colored-${ linkColor } text--strong ` } align={ FlexAlign.CENTER }>
                          <FlexItem>{ label }</FlexItem>
                          { icon &&
                            <FlexItem className={ 'margin-sm-left' }>
                                <Icon name={ icon } color={ iconColor }/>
                            </FlexItem> }
                      </Flexbox>
                  }
                  className={ classNames( { 'padding-xs-vertical padding-md-horizontal container--rounded': !className }, className ) }
                  { ...dropdownProps }>

            <Dropdown.Menu style={ direction === 'right' ? { left: 'auto', right: 0 } : {} }>

                {/* IMAGE GEN / DOWNLOAD */ }
                { _.isFunction( props.onSaveImage ) &&
                  <Dropdown.Item onClick={ props.onSaveImage } content={ <><Icon name={ 'picture' } color={ 'purple' }/> Save as Image</> }/> }

                {/* CSV DATA LINK */ }
                { !_.isEmpty( props.csvData ) &&
                  <Dropdown.Item onClick={ handleCSVAreaClicked } content={
                      <>
                          <Icon onClick={ handleCSVIconClicked } name={ 'table' } color={ 'purple' }/>{ ' ' }
                          <span ref={ csvLinkRef }><CSVLink onClick={ handleCSVLinkClicked } { ...props.csvData } style={ { color: 'inherit' } }>Save as CSV</CSVLink></span>
                      </>
                  }/> }

                {/* COPY TO CLIPBOARD */ }
                { ( _.isFunction( props.onCopyToClipboard ) || !_.isEmpty( props.copyToClipboardText ) ) &&
                  <CopyToClipboard text={ props.copyToClipboardText } onCopy={ props.onCopyToClipboard }>
                      <Dropdown.Item content={ <><Icon name={ 'copy outline' } color={ 'purple' }/> Copy to Clipboard</> }/>
                  </CopyToClipboard> }

            </Dropdown.Menu>

        </Dropdown>
    );
};

DataCopyMenu.defaultProps = defaultProps;

export { DataCopyMenu }
